import formatDecimal from'./format-decimal';let prefixExponent;const formatPrefixAuto=(a,b)=>{var c=Math.max;const e=formatDecimal(a,b);let d,f,g,h;return e?(d=e[0],f=e[1],g=f-(prefixExponent=3*c(-8,Math.min(8,Math.floor(f/3))))+1,h=d.length,g==h?d:g>h?d+Array(g-h+1).join('0'):0<g?d.slice(0,g)+'.'+d.slice(g):'0.'+Array(1-g).join('0')+formatDecimal(a,c(0,b+g-1))[0]):a+''};export{prefixExponent};export default formatPrefixAuto;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-utils/src/number-converter/format-prefix-auto.js
// module id = null
// module chunks = 